import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Terms.css';
import { useHistory, useLocation } from 'react-router';
import axiosInstance from '../../common/interceptor';
import { HOST } from '../../common/constant';

type TermsProp = {
    onNavi: Function,
    userRoleId?: number,
    termsText: string
}

const Terms = (props: TermsProp) => {
    const { pathname } = useLocation();
    const history = useHistory();

    const [isReadComplete, setIsReadComplete] = React.useState(false);
    const termsRef = React.useRef<HTMLDivElement>(null);

    const handleScroll = () => {
        if (!termsRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = termsRef.current;
        const isAtBottom = scrollHeight - scrollTop - clientHeight < 20;

        if (isAtBottom && !isReadComplete) {
            setIsReadComplete(true);
        }
    };

    const onCancel = () => {
        props.onNavi('/');
    }

    const handleAgree = () => {
        axiosInstance.post(HOST() + '/Form/V1/Mst/System/ArgeeTerms')
            .then(response => {
                if (response.data && response.status === 200) {

                    const urlParams = new URLSearchParams(
                        window.location.search
                    );
                    const lat = urlParams.get("lat");
                    const lng = urlParams.get("lng");
                    let redirectUrl = "/"
                    if (lat && lng) {
                        redirectUrl = `/?lat=${lat}&lng=${lng}`;
                    }
                    props.userRoleId === -1
                        ? history.replace("/admin")
                        : history.push(redirectUrl);
                } else {
                    onCancel();
                }
            }
            ).catch(error => { onCancel() });
    }

    return (
        <div className='wrapper'>
            <button onClick={onCancel} className='close-button'>
                <FontAwesomeIcon icon={faTimes} size='lg'></FontAwesomeIcon>
            </button>
            <div
                className='terms'
                ref={termsRef}
                onScroll={handleScroll}
                dangerouslySetInnerHTML={{ __html: props.termsText }} />
            {pathname == '/login' && (
                <div className='terms-button'>
                    <button className='btn btn-primary' disabled={!isReadComplete} onClick={handleAgree}>
                        同意する
                    </button>
                    <button className='btn btn-primary' onClick={onCancel}>
                        同意しない
                    </button>
                </div>
            )}
        </div>

    )
}

export default Terms;